import React, { useState } from "react";
import Marquee from "react-fast-marquee";
import {Parallax} from "react-scroll-parallax";

import Footer from "../../components/Footer";
import Navbar from "../../components/Navbar";
import {ALERT_TYPES, BUTTON_TYPES} from "../../types";
import {Input, Button} from "../../components/common";
import {WhiteMailIcon, WhitePhone} from "../../components/icons";
import {ThankYouModal} from "../../components/modal";
import {useMutation} from "react-query";
import * as Yup from "yup";
import {phoneRegex} from "../../utils/regex";
import {useFormik} from "formik";
import {useAlert} from "../../components/common/Alert";
import {WriteUs} from "../../components/ui";

const info = [
  {
    title: '10 000+',
    subtitle: 'Оформленных банковских продуктов'
  },
  {
    title: '50 млн+',
    subtitle: 'Выплаченных вознаграждений'
  },
  {
    title: '20+',
    subtitle: 'Сотрудников в офисах'
  },
  {
    title: '350+',
    subtitle: 'Зарегистрированных агентов'
  },
  {
    title: '10+',
    subtitle: 'Банков партнеров'
  },
  {
    title: '40 000+',
    subtitle: 'Обработанных заявок'
  },
];

function About() {
  const { setAlert } = useAlert();
  const [isOpenModal, setIsOpenModal] = useState<boolean>(false);

  const handleOpenModal = () => {
    setIsOpenModal(true);
  }

  const handleCloseModal = () => {
    setIsOpenModal(false);
  }

  if (isOpenModal) {
    return <ThankYouModal open={isOpenModal} onClose={handleCloseModal} />;
  }

  return (
    <>

      <div className="relative w-full pt-12 px-4 flex flex-col items-center bg-siteBg lg:h-screen">
        <div className="max-w-[1320px] w-full mx-auto">
          <Navbar />
        </div>

        <div className="lg:hidden">
          <Marquee speed={100} gradient={false}>
            <p className="text-[15vh] mt-5 relative z-0 lg:text-[50px]">
              РАБОТАЕМ С ЛИДЕРАМИ БАНКОВСКОЙ ИНДУСТРИИ&nbsp;&nbsp;
            </p>
          </Marquee>
        </div>

        <div className="hidden lg:block lg:mt-[150px] lg:text-center">
          <p className="text-[45px] font-bold">Работаем с лидерами банковской индустрии</p>
        </div>
      </div>

      <div className="relative mt-[130px] max-w-[1320px] px-5 mx-auto lg:mt-8">
        <p className="relative text-black font-bold text-[32px] leading-[39px] mb-4 z-50">Компания BeeToBee</p>
        <p className="max-w-[662px] text-black text-[16px] leading-[18px] font-medium">
          Компания BeeToBee c 2021 года помогает предпринимателям по всей России зарабатывать на рекомендациях финансовых продуктов. <br /><br />
          Мы являемся крупнейшим партнером ведущих Российских банков. <br /><br />
          За это время через нашу платформу было оформлено более 10 000 банковских продуктов, а наши агенты заработали свыше 50 000 000 рублей
        </p>
        <div className="absolute right-[-50px] top-[-200%] lg:right-[15px] lg:top-[-150%] sm:hidden">
          <Parallax speed={-20}>
            <img src="/parallax/1.png" alt="1" className="w-[600px] h-[600px] lg:w-[100px] lg:h-[100px] sm:hidden lg:z-0"/>
          </Parallax>
        </div>
      </div>

      <div className="max-w-[1320px] px-5 mt-[210px] mx-auto lg:mt-10">
        <ul className="grid grid-cols-3 relative z-50 lg:grid-cols-1 lg:text-center">
          {
            info?.map((i, index) => (
              <li key={index} className="lg:mb-5">
                <p className="font-bold text-mainBlack text-[64px] leading-[78px] mb-1">{i.title}</p>
                <span className="text-[14px] leading-[16px] text-mainBlack/80">{i.subtitle}</span>
              </li>
            ))
          }
        </ul>
      </div>


      <Parallax speed={-20}>
        <div className="px-5 pt-[300px] pb-[150px] mx-auto flex items-center justify-center bg-parallaxAboutBG bg-center bg-no-repeat lg:bg-left lg:py-21">
          <div className="max-w-[920px] text-center">
            <p className="mb-3 text-darkGray text-[32px] leading-[39px] font-bold">
              Мы работаем с профессионалами рынка
            </p>
            <span className="text-mainBlack/75 text-[14px] leading-[16px]">И вы один из них</span>
          </div>
        </div>
      </Parallax>

      <WriteUs handleOpenModal={handleOpenModal} />

      <Footer />

    </>
  );
}

export default About;
